import React from "react";

function ScrollToTopSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      version="1"
      viewBox="0 0 283.5 283.5"
    >
      <defs>
        <clipPath id="d6108a4a51">
          <path d="M1.527 1.527h280.5v280.5H1.527zm0 0"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#d6108a4a51)">
        <path
          fill="#1e3a8a"
          d="M66.648 170.84l70.125-96.672a9.192 9.192 0 015.004-2.516 9.19 9.19 0 015.008 2.516l70.125 96.672c3.512 5.004 1.492 11.008-4.508 11.008h-26.047a8.979 8.979 0 01-5.007-4.012l-37.551-54.586-1.52-1.516-1.496 1.516-38.074 54.586a8.984 8.984 0 01-5.004 4.012h-26.05c-6.524 0-8.516-6.004-5.005-11.008zm75.13 111.187a140.136 140.136 0 0099.163-41.086 140.136 140.136 0 0041.086-99.164 140.133 140.133 0 00-41.086-99.16 140.238 140.238 0 00-99.164-41.09 140.235 140.235 0 00-99.16 41.09 140.235 140.235 0 00-41.09 99.16c0 24.606 6.477 48.809 18.805 70.125a140.115 140.115 0 0051.32 51.325 140.106 140.106 0 0070.125 18.8"
        ></path>
      </g>
    </svg>
  );
}

export default ScrollToTopSvg;
